import React from "react";
import PropTypes from "prop-types";

interface CheckboxInputProps {
  name: string;
  label: string;
  onChange: (value: boolean) => void;
  checked: boolean;
  error: string | undefined;
  helpText?: string | undefined;
}

const CheckboxInput = ({ name, label, checked, onChange, error, helpText }: CheckboxInputProps) => {
  const helpId = helpText ? `${name}-help` : undefined;
  const errorId = error ? `${name}-error` : undefined;
  const describedBy = [helpId, errorId].filter(Boolean).join(" ") || undefined;
  return (
    <div className="form-group">
      {/* visual heading only; the checkbox is named by its own label below (avoids reading the text twice) */}
      <div aria-hidden="true">{label}</div>
      <div className="field">
        <span>
          <input
            type="checkbox"
            id={name}
            name={name}
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            aria-describedby={describedBy}
            aria-invalid={error ? true : undefined}
          />{" "}
          {/* clicking a label linked with htmlFor toggles the checkbox natively, so no onClick here */}
          <label htmlFor={name}>{label}</label>
          <br />
        </span>
        {error && (
          <div id={errorId} className="alert alert-danger">
            {error}
          </div>
        )}
        {helpText && (
          <div id={helpId} className="form-text mx-2 text-muted text-end">
            {helpText}
          </div>
        )}
      </div>
    </div>
  );
};

CheckboxInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  error: PropTypes.string,
};

export default CheckboxInput;
